<template>
  <div class="footer-devices">
    <div class="container">
      <span class="device">
        Desktop
      </span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FooterDevices',
};
</script>

<style scoped>
.footer-devices {
  background-color: black;
  color: white;
  height: 48px;
  width: 100%;
}

.container {
  max-width: 1258px;
  padding-top: 9px;
  display: flex;
  flex-direction: row;
  align-content: center;
}

.device {
  border: 1px solid white;
  display: block;
  line-height: 26px;
  font-size: 12px;
  padding: 1px 5px;
  height: 26px;
  width: auto;
}
</style>
